import {Alert} from "react-bootstrap";

const Error:React.FC<{heading?:string, message: string}> = (props) => {
    return (
        <Alert variant="danger">
            <Alert.Heading>{props.heading || "Error!"}</Alert.Heading>
            <p>{props.message}</p>
        </Alert>
    );
}

export default Error;